

import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { listadoOpsTodas, listadoOpsXUser, opPorID } from "../../../services";
import { useSearchParams } from "react-router-dom";




export const useOPXID = (id) => {
    const { data, isLoading } = useQuery({
        queryKey: ['op-id', { id }], 
        queryFn: () => opPorID(id),
        enabled: !!id,
    });

    return { data, isLoading }
}



export const useListOpTodas = () => {
    
    const [searchParams, setSearchParams] = useSearchParams();
    
    const page = parseInt(searchParams.get('page') || '0');
    const termino = searchParams.get('termino') || '';
    const inicio = searchParams.get('inicio') || '';
    const final = searchParams.get('final') || '';

    const { data, isLoading } = useQuery({
        queryKey: ['todas-ops', { page, termino, inicio, final }], 
        queryFn: () => listadoOpsTodas({ page, termino, inicio, final }),
        // staleTime: 1000 * 60 * 5
    });


    const chagePage = useCallback((num) => {
        setSearchParams(prev => {
            prev.set('page', (num - 1).toString());
            return prev;
        }, { replace: true });
    }, [setSearchParams]);


    const chageTermino = useCallback((valor) => {
        setSearchParams(prev => {
            prev.set('termino', valor);
            prev.set('page', '0');
            return prev;
        }, { replace: true });
    }, [setSearchParams]);


    const chageInicio = useCallback((valor) => {
        setSearchParams(prev => {
            prev.set('inicio', valor);
            prev.set('page', '0');
            return prev;
        }, { replace: true });
    }, [setSearchParams]);


    const chageFinal = useCallback((valor) => {
        setSearchParams(prev => {
            prev.set('final', valor);
            prev.set('page', '0');
            return prev;
        }, { replace: true });
    }, [setSearchParams]);



    return {
        // Estados
        page,
        termino,
        inicio,
        final,
        // Métodos
        chagePage,
        chageTermino,
        chageInicio,
        chageFinal,
        // Data
        data, 
        isLoading,
    }
}



export const useListOpXUsuario = (id, estadoPago) => {
    
    const [searchParams, setSearchParams] = useSearchParams();
    
    const page = parseInt(searchParams.get('page') || '0');
    const termino = searchParams.get('termino') || '';
    const inicio = searchParams.get('inicio') || '';
    const final = searchParams.get('final') || '';


    const { data, isLoading } = useQuery({
        queryKey: ['ops-xuser', { page, termino, inicio, final, id, estadoPago }], 
        queryFn: () => listadoOpsXUser({ page, termino, inicio, final, id, estadoPago }),
        // staleTime: 1000 * 60 * 5
    });


    const chagePage = useCallback((num) => {
        setSearchParams(prev => {
            prev.set('page', (num - 1).toString());
            return prev;
        }, { replace: true });
    }, [setSearchParams]);


    const chageTermino = useCallback((valor) => {
        setSearchParams(prev => {
            prev.set('termino', valor);
            prev.set('page', '0');
            return prev;
        }, { replace: true });
    }, [setSearchParams]);


    const chageInicio = useCallback((valor) => {
        setSearchParams(prev => {
            prev.set('inicio', valor);
            prev.set('page', '0');
            return prev;
        }, { replace: true });
    }, [setSearchParams]);


    const chageFinal = useCallback((valor) => {
        setSearchParams(prev => {
            prev.set('final', valor);
            prev.set('page', '0');
            return prev;
        }, { replace: true });
    }, [setSearchParams]);



    return {
        // Estados
        page,
        termino,
        inicio,
        final,
        // Métodos
        chagePage,
        chageTermino,
        chageInicio,
        chageFinal,
        // Data
        data, 
        isLoading,
    }
}